module.exports = __webpack_public_path__ + "media/sfx_chat_2.22a18b3b.mp3";